import { chakra } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useApiQuery from 'lib/api/useApiQuery';
import { HOMEPAGE_STATS } from 'stubs/stats';
import { Image } from 'toolkit/chakra/image';
import { Skeleton } from 'toolkit/chakra/skeleton';

import TokenLogoPlaceholder from './TokenLogoPlaceholder';
import getNativeTokenIconUrl from './getNativeTokenIconUrl';

type Props = {
  isLoading?: boolean;
  className?: string;
  type?: 'primary' | 'secondary';
};

const NativeTokenIcon = ({ isLoading, className, type }: Props) => {
  const symbol = type === 'secondary' ? config.chain.secondaryCoin.symbol : config.chain.currency.symbol;
  const fixedIcon = getNativeTokenIconUrl(symbol);
  const statsQueryResult = useApiQuery('general:stats', {
    queryOptions: {
      enabled: !fixedIcon,
      refetchOnMount: false,
      placeholderData: HOMEPAGE_STATS,
    },
  });

  if (isLoading || (!fixedIcon && statsQueryResult.isPlaceholderData)) {
    return <Skeleton borderRadius="base" loading className={ className }/>;
  }

  const src = fixedIcon || (type === 'secondary' ? statsQueryResult.data?.secondary_coin_image : statsQueryResult.data?.coin_image);

  return (
    <Image
      className={ className }
      borderRadius="base"
      src={ src || undefined }
      alt={ `${ symbol || config.chain.currency.symbol } logo` }
      fallback={ <TokenLogoPlaceholder/> }
    />
  );
};

export default chakra(NativeTokenIcon);
